export const EVALUATION_SENT_DIALOG_CLASS_NAME = 'evaluation-sent-dialog';
export const EVALUATION_SENT_DIALOG_ICON_CLASS_NAME = 'evaluation-sent-dialog-icon';
export const EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME = 'evaluation-sent-dialog-description';

const COMPACT_DIALOG_CLASS_NAME = 'compact-dialog';

export default COMPACT_DIALOG_CLASS_NAME;
